import React, { memo, useState } from 'react'
import cn from 'classnames'

import { ReactComponent as HamburgerIcon } from '../assets/icons/hamburgerIcon.svg'
import { ReactComponent as HamburgerIconMobile } from '../assets/icons/hamburgerIconMobile.svg'
import BackButtonChevron from './BackButtonChevron'
import NetworkIndicator from './NetworkIndicator'
import { ButtonBase } from '@material-ui/core'
import styles from './VNConcessionsNavBar.module.scss'

import NavMenu from '../components/NavMenu'
import useGetIsMobileScreen from '../hooks/useGetIsMobileScreen'

import { isTestMode, isE700Device } from '../VNAndroidSDK/Utils'

// TODO (mkramerl): Merge this with NavBar to have a single NavBar component.
const VNConcessionsNavBar = ({
  textDisplay = '',
  onClick = () => {},
  cardReaderInitialized,
  cardReaderScreen,
  className,
  useHamburgerIcon,
  showIcon = true,
  leftAccessory,
  rightAccessory,
  showBorder = true,
  useSmallTitleFont = false,
}) => {
  const classNames = cn(styles.vnConcessionsNavBar, className, showBorder && styles.showBorder, {
    [styles.hasHamburger]: useHamburgerIcon,
  })
  const isMobileViewPort = useGetIsMobileScreen()

  const [isHamburgerMenuOpen, setIsHamburgerMenuOpen] = useState(false)
  const openHamburgerMenu = () => setIsHamburgerMenuOpen(true)
  const closeHamburgerMenu = () => setIsHamburgerMenuOpen(false)
  const hamburgerIcon = isMobileViewPort ? (
    <HamburgerIconMobile onClick={openHamburgerMenu} />
  ) : (
    <HamburgerIcon onClick={openHamburgerMenu} />
  )

  const backButtonIcon = <BackButtonChevron onClick={onClick} backButtonText={isMobileViewPort ? null : 'Go Back'} />

  if (useHamburgerIcon) {
    leftAccessory = hamburgerIcon
  } else if (!leftAccessory) {
    leftAccessory = backButtonIcon
  }

  const rightIcon = rightAccessory && isMobileViewPort ? rightAccessory : <NetworkIndicator />
  const suffix = isTestMode() ? ' (Test)' : ''

  const navBarCenterText = textDisplay && (
    <div className={useSmallTitleFont && isMobileViewPort ? styles.smallTitle : styles.title}>{textDisplay + suffix}</div>
  )

  const cardReaderIndicator = cardReaderScreen && (
    <>
      <div className={styles.cardReaderDots} />
      {cardReaderInitialized && <div className={cn([styles.cardReaderDots, styles.cardReaderInitialized])} />}
    </>
  )

  const getBorder = () => {
    if (showBorder) {
      return {}
    }

    return {
      border: 'none',
    }
  }

  return (
    <section className={classNames} style={getBorder()}>
      <div className={styles.leftAccessory}>
        {showIcon && (
          <ButtonBase disableRipple={isE700Device()} component="div" className={styles.iconContainer}>
            {leftAccessory}
          </ButtonBase>
        )}
      </div>
      {navBarCenterText}
      <div className={styles.rightAccessory}>{rightIcon}</div>
      {isHamburgerMenuOpen && <NavMenu onToggle={closeHamburgerMenu} />}
      {cardReaderIndicator}
    </section>
  )
}

export default memo(VNConcessionsNavBar)
